// SubscriptionModal.jsx
import React from 'react';
import css from './SubscriptionModal.module.css';
import subscriptionModalImg from '../../../assets/subscriptionModalImg.png';
import { IconSpinner } from '../../../components';
import {
  getTrialChargeDateFromSubscription,
  isSubscriptionTrialing,
} from '../../../util/trialBilling';

const SubscriptionModal = ({
  isOpen,
  onNext,
  intl,
  stripeSessionError,
  isNextLoading,
  subscription = null,
}) => {
  if (!isOpen) return null;

  const trialChargeDate = getTrialChargeDateFromSubscription(subscription);
  const showTrialMessage = !stripeSessionError && isSubscriptionTrialing(subscription);
  const formattedTrialChargeDate = trialChargeDate
    ? intl.formatDate(trialChargeDate, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    : null;

  return (
    <div className={css.overlay}>
      <div className={css.modal}>
        <div className={css.imageContainer}>
          {/* Replace with your actual image path */}
          <img src={subscriptionModalImg} alt="Subscription Img" className={css.image} />
        </div>
        <h2 className={css.title}>
          {stripeSessionError
            ? intl.formatMessage({ id: 'ProgramOnboardingPage.subscriptionModal.failedTitle' })
            : intl.formatMessage({ id: 'ProgramOnboardingPage.subscriptionModal.successTitle' })}
        </h2>
        {showTrialMessage ? (
          <p className={css.description}>
            {intl.formatMessage({
              id: 'ProgramOnboardingPage.subscriptionModal.trialNoChargeToday',
            })}
            {formattedTrialChargeDate ? (
              <>
                {' '}
                {intl.formatMessage(
                  { id: 'ProgramOnboardingPage.subscriptionModal.trialChargeDate' },
                  { date: formattedTrialChargeDate }
                )}
              </>
            ) : null}
          </p>
        ) : null}
        <div className={css.actions}>
          <button className={css.nextButton} onClick={onNext}>
            {isNextLoading ? (
              <IconSpinner showWhiteSpinner />
            ) : (
              intl.formatMessage({ id: 'ProgramOnboardingPage.subscriptionModal.next' })
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionModal;
